import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React ,{useState} from "react";
import { useAddAdminGroupMutation} from "../../../Services/api";

export default function Create() {
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [addAdminGroup,isLoading] = useAddAdminGroupMutation();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('title', values.title);
        addAdminGroup( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                 e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
   
   
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Group Details</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                <div className="col-sm-10">
                                    <input type="title" {...register("title" ,{ required: true})} className="form-control" />
                                    {errors.title && <span  className="text-danger">Title is required</span>}
                                </div>
                            </div>

                            
                            
                          <div className="modal-footer">
                                
                                {isLoading.status !='pending' ? 
                                 <>
                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                 </>     
                                :
                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}